// services/httpClient.ts must be the unified axios client we set up earlier.
import http from "services/httpClient";
import { People, DeviceSsd, HddNetwork, RssFill } from "react-bootstrap-icons";
import { ProjectsStatsProps } from "types";

export interface AuthUser {
  id: number;
  email: string;
  role: string;
}

type SummaryResponse = {
  users: number;
  devices: number;
  ftp_devices: number;
  mqtt_devices: number;
};

export const fetchServerStats = async (user: AuthUser): Promise<ProjectsStatsProps[]> => {
  try {
    const endpoint =
      user?.role === "client"
        ? "/dashboard/client_summary"
        : "/dashboard/summary";

    const { data } = await http.get<SummaryResponse>(endpoint);

    const stats: ProjectsStatsProps[] = [
      { id: 1, title: "Users",        value: data.users ?? 0,        icon: <People size={18} /> },
      { id: 2, title: "Devices",      value: data.devices ?? 0,      icon: <DeviceSsd size={18} /> },
      { id: 3, title: "FTP Devices",  value: data.ftp_devices ?? 0,  icon: <HddNetwork size={18} /> },
      { id: 4, title: "MQTT Devices", value: data.mqtt_devices ?? 0, icon: <RssFill size={18} /> },
    ];

    return stats;
  } catch (err) {
    // console.error("Error fetching server stats", err);
    return [];
  }
};
